import React, {useEffect, useState} from "react";
import {EditorState} from "draft-js";
import {updateMentions} from "tools/comment/helpers";
import Editor from "@draft-js-plugins/editor";
import {mentionDecorator} from "tools/comment";
import {v4 as uuid} from "uuid";

type Props = {
  text: string;
  id?: string;
  organisers?: {id: string; name: string}[];
};
const CommentText = ({text, id, organisers}: Props) => {
  const [editorState, setEditorState] = useState(() =>
    EditorState.createEmpty(mentionDecorator)
  );
  useEffect(() => {
    if (!text) {
      return;
    }
    const rawContent = JSON.parse(text);
    const contentState = updateMentions(rawContent, organisers);
    setEditorState((prev) =>
      EditorState.push(prev, contentState, "change-block-data")
    );
  }, [text, organisers]);
  return <Editor editorKey={id || uuid()} readOnly editorState={editorState} />;
};
export default CommentText;
